import { PdfService } from 'src/app/_services';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';

export class PdfModel {
    constructor(private pdfService: PdfService, private empId: string) {

    }

    savePdf(filename: string) {
        console.debug('PdfModel().savePdf()');
        this.pdfService.setPdfModel().subscribe((response: any) => {

            let pdfQueueKey = response.body.pdfQueueKey;
            console.debug(`pdfQueueKey: ${pdfQueueKey}`);

            if (environment.switches.isTestingToolVisible) {
                //open preview in new window//
                window.open(`/qantas/retbenefit/soa?empId=${this.empId}&pdfQueueKey=${pdfQueueKey}`);
            }
            else {
                console.debug(`/qantas/retbenefit/soa?empId=${this.empId}&pdfQueueKey=${pdfQueueKey}`);
            }

            //this.pdfService.generate(pdfQueueKey);

            this.pdfService.generate(pdfQueueKey).subscribe(
              success => {
                saveAs(success, filename);
              },
              failed => {
                saveAs(failed, filename);
              }
            );

        }, (response: any) => {
            console.error(response);
            this.pdfService.isGeneratingSoA = false;
        });
    }
}
